



























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { RefundModel, StatementModel } from '@/app/shared/models';
@Component({
  components: {},
})
export default class DialogRefundHistory extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  private loading = false;

  private get refs() {
    return refsService;
  }
  private get list() {
    const allList = [];
    const listRefunds = this.refs.modules.contract.refundsByContract;
    for (const refund of listRefunds) {
      if (
        refund.InstallmentId?.toUpperCase() ==
        this.refs.modules.contract.installment.Id?.toUpperCase()
      ) {
        allList.push(refund);
      }
    }
    return allList;
  }
  private concatString(statements: StatementModel[], column: string) {
    let result = '';
    statements.forEach((statement) => {
      if (column == 'TransactionDate') {
        result += statement.TransactionDate
          ? this.$d(new Date(statement.TransactionDate), 'hour')
          : '--';
        result += '<br>';
      }
      if (column == 'PaymentInfoPaymentMethod') {
        const current = this.refs.static.enumDescriptions.get2(
          this.refs.enums.PaymentMethod,
          statement.PaymentInfoPaymentMethod
        );

        result += result.includes(current) ? '' : current;
        result += result.includes(current) ? '' : '<br>';
      }
    });
    return result;
  }
  private externalRefund(item: RefundModel) {
    const external = item.ExternalRefundCovenantId || 0;
    return external > 0
      ? this.$t('texts.yes').toString()
      : this.$t('texts.no').toString();
  }

  private async download(refundId: string) {
    const contractNumber = this.refs.modules.contract.contract.Number?.toString();
    const contractName = this.refs.modules.contract.contract.Customers?.[0]
      .Name;
    const file = await this.refs.modules.contract.getRefundFile(refundId);
    if (file != null && file != undefined) {
      const fileObject = window.URL.createObjectURL(file);
      const doc = document.createElement('a');
      doc.href = fileObject;
      doc.setAttribute(
        'download',
        contractName + ' ' + contractNumber + '.pdf'
      );
      document.body.appendChild(doc);
      doc.click();
    } else {
      this.$toast.error(this.$t('toasts.refund_file_not_found'));
    }
  }
}
